import { toDate } from "shared/mappers";
import type {
  MyMeetingListItem,
  MyMeetingListItemDto,
  MyMeetingTimeframe,
  MyMeetingTimeframeDto,
} from "meetings/shared/types";

const timeframeFromDto = (
  dto?: MyMeetingTimeframeDto | null,
): MyMeetingTimeframe | null =>
  dto
    ? {
        openAt: toDate(dto.open_at),
        closedAt: toDate(dto.closed_at),
        closedNoModifyAt: toDate(dto.closed_no_modify_at),
      }
    : null;

export const myMeetingFromDto = (
  dto: MyMeetingListItemDto,
): MyMeetingListItem => ({
  id: dto.id,
  name: dto.name,
  status: dto.status,
  meetingType: dto.meeting_type,
  // The backend sends either timeframe_settings or timeframes; collapse both
  // into a single client-side timeframe so the rest of the app has one shape.
  timeframe: timeframeFromDto(dto.timeframe_settings ?? dto.timeframes),
  hasSubmittedFeedback: dto.has_submitted_feedback ?? false,
  totalRatings: dto.total_ratings ?? 0,
  totalGivenRatings: dto.total_given_ratings ?? 0,
});
